export class BaseSelectBoundRenderer {
	constructor (ctx, grid) {
		this.ctx = ctx
		this.grid = grid
	}

	afterRowRendered (rect) {
	}

	afterAllRowRendered (rect) {
	}

	select (rowIndex, e) {

	}

	clear () {

	}

	getSelectedIndice () {
		return []
	}
}

export class CellRenderer extends BaseSelectBoundRenderer {
	afterRowRendered (rect) {
		const rowHeight = this.grid.rowHeight
		const { col, rowIndex } = this.grid.currentCellInfo
		const { firstRenderRowIdx, firstOffsetTop, renderRowCount } = this.grid.calcRowRenderInfo(rect)
		const offsetTop = firstOffsetTop + rowHeight * (rowIndex - firstRenderRowIdx)

		if (firstRenderRowIdx <= rowIndex && rowIndex <= firstRenderRowIdx + renderRowCount) {
			var { offsetLeft } = this.grid.findColById(col.id, rect)

			this.ctx.useContext2d(ctx2d => {
				ctx2d.strokeStyle = this.ctx.gridStyle.selectBorderColor
				ctx2d.lineWidth = 1.5
				this.ctx.strokeRect(offsetLeft + 1, offsetTop + 1, col.actualWidth - 2, rowHeight - 2)
				// 固定列でなければ、固定列を再描画して被さらないようにする
				if (!col.options.fixed) {
					const row = this.grid.rows[rowIndex]
					const cellInfos = this.grid.cellInfoMap[row.id] || {}
					row.renderFixedCells(this.ctx, { offsetTop, fixedCols: this.grid.fixedCols, height: rowHeight, rowIndex: rowIndex, isLastRow: true, cellInfos }) // isLastRowじゃないが…カラムのキャッシュデータ削除のためtrue渡す
				}
			})
		}
	}
}

export class RowSelectBoundRenderer extends BaseSelectBoundRenderer {
	#rowIndex

	select (rowIndex, e) {
		this.#rowIndex = rowIndex
	}

	afterAllRowRendered (rect) {
		if (this.#rowIndex == null || this.#rowIndex < 0) {
			return
		}
		const rowHeight = this.grid.rowHeight
		const { firstRenderRowIdx, firstOffsetTop } = this.grid.calcRowRenderInfo(rect)
		const offsetTop = firstOffsetTop + rowHeight * (this.#rowIndex - firstRenderRowIdx)
		this.ctx.useContext2d(ctx2d => {
			ctx2d.strokeStyle = this.ctx.gridStyle.selectBorderColor
			ctx2d.lineWidth = 1.5
			this.ctx.strokeRect(0 + 1, offsetTop + 1, this.grid.width - 2, rowHeight - 2)
		})
	}

	clear () {
		this.#rowIndex = null
	}

	getSelectedIndice () {
		return this.#rowIndex == null ? [] : [this.#rowIndex]
	}
}

export class MultiRowSelectBoundRenderer extends BaseSelectBoundRenderer {
	/**
	 * @type {number[][]}
	 */
	selectedRowIndices = []
	afterAllRowRendered (rect) {
		// if (!this.ctx.currentCellInfo) {
		// 	return
		// }
		const rowHeight = this.grid.rowHeight
		const { firstRenderRowIdx, renderRowCount, firstOffsetTop } = this.grid.calcRowRenderInfo(rect)
		let lastRenderIndex = firstRenderRowIdx + renderRowCount
		if (lastRenderIndex >= this.grid.rows.length) {
			lastRenderIndex = this.grid.rows.length - 1
		}

		const groupBySerial = (acc, cur) => {
			let found = false
			acc.forEach(group => {
				const min = Math.min(...group)
				const max = Math.max(...group)

				if (min - 1 === cur || max + 1 === cur) {
					found = true
					group.push(cur)
				}
			})
			if (!found) {
				acc.push([cur])
			}
			return acc
		}
		const selectedIndicesGroups = this.selectedRowIndices.sort((a, b) => a - b).reduce(groupBySerial, [])

		selectedIndicesGroups.forEach(selectedIndices => {
			const minIndex = Math.min(...selectedIndices)
			const maxIndex = Math.max(...selectedIndices)

			if ((firstRenderRowIdx <= minIndex && minIndex <= lastRenderIndex) ||
				(firstRenderRowIdx <= maxIndex && maxIndex <= lastRenderIndex) ||
				(minIndex < firstRenderRowIdx && lastRenderIndex < maxIndex)) {
				const offsetTop = (minIndex - firstRenderRowIdx) * rowHeight + firstOffsetTop
				const boundHeight = (maxIndex - minIndex + 1) * rowHeight

				this.ctx.useContext2d(ctx2d => {
					ctx2d.strokeStyle = this.ctx.gridStyle.selectBorderColor
					ctx2d.lineWidth = 1.5
					this.ctx.strokeRect(0 + 1, offsetTop + 1, this.grid.width - 2, boundHeight - 2)
				})
			}
		})
	}

	select (rowIndex, col, { shiftKey, ctrlKey } = {}) {
		if (rowIndex === -1) {
			const updated = this.selectedRowIndices.length > 0
			this.selectedRowIndices = []
			return updated
		} else if (this.selectedRowIndices.length > 0) {
			let updated = false
			// 既に選択行がある場合

			if (shiftKey) {
				// シフトキー＋クリック
				const min = Math.min(...this.selectedRowIndices)
				const max = Math.max(...this.selectedRowIndices)
				if (rowIndex < min) {
					for (let i = rowIndex; i < min; i++) {
						this.selectedRowIndices.push(i)
					}
					updated = true
				} else if (rowIndex > max) {
					for (let i = max + 1; i <= rowIndex; i++) {
						this.selectedRowIndices.push(i)
					}
					updated = true
				}
			} else if (ctrlKey) {
				// ctrlキー＋クリック
				if (!this.selectedRowIndices.includes(rowIndex)) {
					this.selectedRowIndices.push(rowIndex)
					updated = true
				} else {
					this.selectedRowIndices = this.selectedRowIndices.filter(index => index !== rowIndex)
					updated = true
				}
				return updated
			} else {
				// クリック
				const updated = this.selectedRowIndices.length !== 1 || this.selectedRowIndices[0] !== rowIndex
				this.selectedRowIndices = [rowIndex]
				return updated
			}
		} else {
			const updated = this.selectedRowIndices.length !== 1 || this.selectedRowIndices[0] !== rowIndex
			this.selectedRowIndices = [rowIndex]
			return updated
		}
	}

	clear () {
		this.selectedRowIndices = []
	}

	getSelectedIndice () {
		return this.selectedRowIndices
	}
}

export class RowColSelectBoundRenderer extends BaseSelectBoundRenderer {
	/**
	 * @typedef {Object} Bound
	 * @property {number} fromRowIndex
	 * @property {number} toRowIndex
	 * @property {import("./column/default").default} fromColumn
	 * @property {import("./column/default").default} toColumn
	 */
	/**
	 * @type {Bound}
	 */
	#selectedBound

	get bound () {
		if (!this.#selectedBound) return null
		return {
			...this.#selectedBound
		}
	}

	selectedRowIndices () {
		if (this.#selectedBound) {
			const indices = []
			for (let i = this.#selectedBound.fromRowIndex; i <= this.#selectedBound.toRowIndex; i++) {
				indices.push(i)
			}
			return [indices]
		} else return []
	}

	afterAllRowRendered (rect) {
		if (!this.#selectedBound) {
			return
		}
		const rowHeight = this.grid.rowHeight
		const { firstRenderRowIdx, renderRowCount, firstOffsetTop } = this.grid.calcRowRenderInfo(rect)
		let lastRenderIndex = firstRenderRowIdx + renderRowCount
		if (lastRenderIndex >= this.grid.rows.length) {
			lastRenderIndex = this.grid.rows.length - 1
		}
		const {
			fromColumn,
			fromRowIndex: minIndex,
			toColumn,
			toRowIndex: maxIndex
		} = this.#selectedBound

		let offsetLeft = 0
		let colWidth = 0
		let fromColDetected = false
		let fixedColTotalWidth = 0
		for (const col of this.grid.allCols) {
			if (col.fixed) {
				fixedColTotalWidth += col.actualWidth
			}
			if (col.id === fromColumn.id) {
				fromColDetected = true
			}
			if (!fromColDetected) {
				offsetLeft += col.actualWidth
			} else {
				colWidth += col.actualWidth
			}
			if (col.id === toColumn.id) {
				break
			}
		}

		let actualOffsetLeft = offsetLeft + 1 - rect.left
		let actualColWidth = colWidth - 2

		if (fromColumn.fixed) {
			// 固定列を含む場合
			actualOffsetLeft = offsetLeft + 1
			actualColWidth -= rect.left
			if (actualColWidth < fromColumn.actualWidth) {
				actualColWidth = fromColumn.actualWidth
			}
		} else if (fixedColTotalWidth > actualOffsetLeft) {
			// 固定列を含まないが、グリッド上に固定列が存在する場合
			const widthDelta = fixedColTotalWidth - actualOffsetLeft
			actualOffsetLeft = fixedColTotalWidth
			actualColWidth -= widthDelta

			if (actualColWidth <= 0) return
		}

		if ((firstRenderRowIdx <= minIndex && minIndex <= lastRenderIndex) ||
				(firstRenderRowIdx <= maxIndex && maxIndex <= lastRenderIndex) ||
				(minIndex < firstRenderRowIdx && lastRenderIndex < maxIndex)) {
			const offsetTop = (minIndex - firstRenderRowIdx) * rowHeight + firstOffsetTop
			const boundHeight = (maxIndex - minIndex + 1) * rowHeight

			this.ctx.useContext2d(ctx2d => {
				ctx2d.strokeStyle = this.ctx.gridStyle.selectBorderColor
				ctx2d.lineWidth = 1.5
				this.ctx.strokeRect(actualOffsetLeft, offsetTop + 1, actualColWidth, boundHeight - 2)
			})
		}
	}

	select (rowIndex, col, { shiftKey, ctrlKey } = {}) {
		if (rowIndex === -1 || col == null) {
			const updated = !!this.#selectedBound
			this.#selectedBound = null
			return updated
		}

		// 既に選択行がある場合
		if (this.#selectedBound && shiftKey) {
			let updated = false
			// シフトキー＋クリック
			const {
				fromColumn,
				fromRowIndex,
				toColumn,
				toRowIndex
			} = this.#selectedBound
			if (rowIndex < fromRowIndex) {
				this.#selectedBound.fromRowIndex = rowIndex
				updated = true
			} else if (rowIndex > toRowIndex) {
				this.#selectedBound.toRowIndex = rowIndex
				updated = true
			}

			const fromColIndex = this.grid.allCols.findIndex(col => col.id === fromColumn.id)
			const toColIndex = this.grid.allCols.findIndex(col => col.id === toColumn.id)
			const colIndex = this.grid.allCols.findIndex(c => c.id === col.id)

			if (colIndex < fromColIndex) {
				this.#selectedBound.fromColumn = col
				updated = true
			} else if (colIndex > toColIndex) {
				this.#selectedBound.toColumn = col
				updated = true
			}
			return updated
		}

		// 新たに選択された場合
		this.#selectedBound = {
			fromRowIndex: rowIndex,
			toRowIndex: rowIndex,
			fromColumn: col,
			toColumn: col
		}
		return true
	}

	clear () {
		this.#selectedBound = null
	}

	getSelectedIndice () {
		return this.selectedRowIndices().flat()
	}
}
